import React, { useEffect } from "react";
import { Typography, Form, Input, DatePicker, Button, message } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import axios from "axios";

const { Title } = Typography;

function UpdateProject() {
  const { projectId } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const accessToken = localStorage.getItem("access-token"); // same as UpdateClient

  // Fetch project by ID
  useEffect(() => {
    const fetchProject = async () => {
      try {
        if (!accessToken) throw new Error("No token found. Please login.");

        const res = await axios.get(`https://rhrmapi.up2dateinc.com/api/projects/${projectId}`, {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (res.data && typeof res.data === "object") {
          // Populate form, convert startDate to dayjs
          form.setFieldsValue({
            projectName: res.data.projectName,
            client: res.data.client,
            projectLead: res.data.projectLead,
            tasks: res.data.tasks,
            summary: res.data.summary,
            startDate: res.data.startDate ? dayjs(res.data.startDate) : null,
            duration: res.data.duration,
            rewardPoints: res.data.rewardPoints,
          });
        } else {
          message.error("Failed to load project data");
        }
      } catch (err) {
        console.error(err);
        message.error(err.response?.data?.message || err.message || "Failed to fetch project");
      }
    };

    fetchProject();
  }, [projectId, form, accessToken]);

  // Update project
  const updateProject = async (values) => {
    try {
      if (!accessToken) throw new Error("No token found. Please login.");

      await axios.put(
        `https://rhrmapi.up2dateinc.com/api/projects/${projectId}`,
        {
          ...values,
          startDate: values.startDate ? values.startDate.format("YYYY-MM-DD") : null,
        },
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      message.success("Project updated successfully");
      navigate("/admin/manage-project");
    } catch (err) {
      console.error(err);
      message.error(err.response?.data?.message || err.message || "Failed to update project");
    }
  };

  return (
    <div>
      <Title level={3}>Update Project</Title>

      <Form layout="vertical" form={form} onFinish={updateProject} style={{ maxWidth: 800 }}>
        <Form.Item name="projectName" label="Project Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="client" label="Client" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="projectLead" label="Project Lead" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="tasks" label="Approximate Tasks" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="summary" label="Summary" rules={[{ required: true }]}>
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item name="startDate" label="Start Date" rules={[{ required: true }]}>
          <DatePicker style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item name="duration" label="Project Duration" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="rewardPoints" label="Reward Points">
          <Input />
        </Form.Item>

        <Button type="primary" htmlType="submit">
          Update Project
        </Button>
      </Form>
    </div>
  );
}

export default UpdateProject;